import { Stack, Tooltip, Typography } from '@mui/material';
import React, { type JSX } from 'react';

export const WidgetHeader = ({
    mode,
    widgetData,
    sortedData,
    count,
    widgetTypeId,
    headerAction,
}: {
    mode: string | undefined;
    widgetData: any;
    sortedData?: any;
    count?: number | string;
    headerAction?: any;
    widgetFilter?: any;
    widgetTypeId?: string;
}): JSX.Element => {
    const { widgetName, isTotalCountVisible } = widgetData || {};
    const secondaryLength = sortedData?.secondary?.length || widgetData?.secondary?.length || 0;
    const displayCount = count ?? secondaryLength;
    const shouldShowDisplayCount = isTotalCountVisible !== false && (Boolean(secondaryLength) || Boolean(displayCount));
    const widgetTooltipTitle = shouldShowDisplayCount ? `${widgetName} (${displayCount})` : widgetName;

    return (
        <Stack
            direction={'row'}
            alignItems={'center'}
            position="relative"
            justifyContent={'space-between'}
            ml={1}
            sx={
                mode?.includes('edit')
                    ? {
                          position: 'absolute',
                          top: '0px',
                          height: '48px',
                          left: widgetTypeId === 'command_bar' && mode === 'pinned-edit' ? '16px' : '50px',
                          width: 'calc(100% - 106px)',
                      }
                    : { height: '48px', padding: '16px', width: 'calc(100% - 8px)' }
            }
            width={'calc(100% - 106px)'}
        >
            <Tooltip title={widgetTooltipTitle} placement="bottom" arrow>
                <Typography
                    variant="subtitle2"
                    color="primary"
                    fontWeight={'600'}
                    fontSize={'14px'}
                    noWrap
                    sx={{ overflow: 'hidden', textOverflow: 'ellipsis', minWidth: 0, flexShrink: 1 }}
                >
                    {widgetName}
                    {shouldShowDisplayCount && <span>{` (${displayCount})`}</span>}
                </Typography>
            </Tooltip>
            {headerAction}
        </Stack>
    );
};
